// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownIcon__C3yKmT2AM6{margin-left:var(--dixa-size-spacer-200)}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/contacts/components/sidebar/components/top/contactsSidebarTop.module.scss"],"names":[],"mappings":"AAEA,0BACE,uCAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.dropdownIcon {\n  margin-left: var(--dixa-size-spacer-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownIcon": `dropdownIcon__C3yKmT2AM6`
};
export default ___CSS_LOADER_EXPORT___;
